exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ghost[data-v-559f7626] {\n    opacity: 0.5;\n    background: #c8ebfb;\n}\n", ""]);

// exports
